// extracted by mini-css-extract-plugin
export default {"btnCTA":"ButtonReg_btnCTA__v8HVb","btnGhost":"ButtonReg_btnGhost__Gyl1y"};